import { render } from "./LotBidArea.vue?vue&type=template&id=3b9aac25&scoped=true"
import script from "./LotBidArea.vue?vue&type=script&lang=js"
export * from "./LotBidArea.vue?vue&type=script&lang=js"

import "./LotBidArea.vue?vue&type=style&index=0&id=3b9aac25&scoped=true&lang=css"

import exportComponent from "/Users/remy/Sites/baghera/WocUp/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9aac25"]])

export default __exports__